var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h2',[_vm._v("SINODALES MDK")]),_c('CRUDIndex',{attrs:{"permissionRoot":'Sinodales',"headers":_vm.headers,"payload":_vm.payload,"storeModel":_vm.storeModel,"itemsPerPage":_vm.itemsPerPage}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }